import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useRouter } from 'next/router';

import { globalConst, IFaq } from '..';

export const useFAQ = () => {
  const { locale } = useRouter(); // 'uz' or 'ru'

  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.FAQ],
    queryFn: async () => {
      const response = await axios.get<{ [lang: string]: IFaq[] }>('/faq.json');
      
      return { faq: response.data[locale ?? 'uz'] };
    }
  });

  return { ...data, ...args };
};
